var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 126,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M172.317 3.698c4.911 4.922 4.911 12.877 0 17.8L71.74 122.307a12.522 12.522 0 01-17.758 0l-50.3-50.405c-4.91-4.923-4.91-12.877 0-17.8 4.91-4.922 12.87-4.922 17.781 0L62.507 95.57 154.56 3.698a12.509 12.509 0 0117.758 0z",
    fill: "url(#_check_svg__paint0_linear_2831_4129)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "_check_svg__paint0_linear_2831_4129",
    x1: 176,
    y1: 63,
    x2: 0,
    y2: 63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00",
    stopOpacity: 0.7
  })))));
}
export default SvgCheck;